import { OodColorVariant } from '../../types/colors';
import { CSSProperties } from 'react';

export const CardStyles = (colorVariant: OodColorVariant): CSSProperties => ({
	display: 'flex',
	height: '100%',
	borderRadius: '6px',
	border: `1px solid ${colorVariant.border}`,
	background: colorVariant.background,
});

export const ChipStyles = (colorVariant: OodColorVariant): CSSProperties => ({
	borderRadius: '40px',
	borderColor: colorVariant.content,
	color: colorVariant.content,
	fontSize: '12px',
	padding: '0 3px',
	height: '28px',
	marginRight: 'auto',
});
